import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";

const CustomDot = ({ onClick, active, index, carouselState }) => {
	const { currentSlide, slidesToShow, totalItems } = carouselState;

	return slidesToShow >= totalItems ? (
		""
	) : (
		<li
			aria-controls={`carousel-${index}`}
			aria-label={`Carousel Item ${index}`}
			style={{ width: "25%" }}
		>
			<button
				className={`carousel-dot ${active ? "active" : ""}`}
				style={{ width: "100%" }}
				onClick={() => onClick()}
			></button>
		</li>
	);
};

const CustomButtonGroupAsArrows = ({ next, previous, carouselState }) => {
	const { slidesToShow, totalItems } = carouselState;

	return slidesToShow >= totalItems ? (
		""
	) : (
		<div className="carousel-btn-wrapper">
			<button className="carousel-btn-prev" onClick={previous}></button>
			<button className="carousel-btn-next" onClick={next}></button>
		</div>
	);
};
export default function CarouselWrapper({ carouselHTML = [] }) {
	const responsive = {
		desktop2: {
			breakpoint: { max: 3000, min: 1265 },
			items: 4,
		},
		desktop: {
			breakpoint: { max: 1265, min: 1010 },
			items: 3,
			partialVisibilityGutter: 40,
		},
		tablet2: {
			breakpoint: { max: 1010, min: 825 },
			items: 2,
			partialVisibilityGutter: 80,
		},
		tablet: {
			breakpoint: { max: 825, min: 625 },
			items: 2,
			partialVisibilityGutter: 0,
		},
		mobile2: {
			breakpoint: { max: 625, min: 480 },
			items: 1,
			partialVisibilityGutter: 120,
		},
		mobile: {
			breakpoint: { max: 480, min: 0 },
			items: 1,
			partialVisibilityGutter: 40,
		},
	};
	return carouselHTML && carouselHTML.length ? (
		<Carousel
			responsive={responsive}
			renderButtonGroupOutside={true}
			renderDotsOutside
			customDot={<CustomDot />}
			showDots
			partialVisible
			arrows={false}
			renderButtonGroupOutside
			customButtonGroup={<CustomButtonGroupAsArrows />}
		>
			{carouselHTML.map((elem, i) => {
				return (
					<div
						key={i}
						dangerouslySetInnerHTML={{ __html: elem.innerHTML }}
					></div>
				);
			})}
		</Carousel>
	) : null;
}
